<div class="bottom-sheet-container">
    <iframe [src]="data | safeUrl" frameborder="0" width="100%" height="100%"></iframe>
</div>
